import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useSelector } from 'react-redux';
import fileExplorerReducer from './features/file-explorer-slice';
import fileListReducer from './features/file-list-slice';
import authReducer from './features/auth-slice';
import usersReducer from './features/users-slice';
import reserveReducer from './features/reserve-slice';
import notificationsReducer from './features/notifications-slice';
import bcrInspectReducer from './features/bcr-inspect-slice';
import loginRecordsReducer from './features/login-logs-slice';
import signatoriesReducer from './features/signatories-slice';
import bcrsReducer from './features/bcrs-slice';
import meetingMinutesReducer from './features/meeting-minutes-slice';
import projectsReducer from './features/projects-slice';
import bcrRecordsReducer from './features/bcr-logs-slice';
import meetingMinuteRecordsReducer from './features/meeting-minute-logs-slice';

export const store = configureStore({
    reducer: {
        fileExplorerReducer,
        fileListReducer,
        authReducer,
        usersReducer,
        reserveReducer,
        notificationsReducer,
        bcrInspectReducer,
        loginRecordsReducer,
        bcrRecordsReducer,
        meetingMinuteRecordsReducer,
        signatoriesReducer,
        bcrsReducer,
        meetingMinutesReducer,
        projectsReducer,
    }
});

// NEED these for typescript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// export const useAppSelector = useSelector<RootState>
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector